<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <p>Role List</p>
          </div>
          <div class="add-block">
            <button (click)="addRole()">Submit</button>
          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 40%;">Role Name</th>
              <th style="width: 40%;">Screen Groups</th>
              <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
            </tr>
          </thead>
        </table>
        <div>
          <div class="data-view" *ngFor="let role of rolesObject;let i = index">

            <p style="width: 40%;">{{role.roleName}}</p>
            <p style="width: 40%;padding-left: 25px;">{{role.screenGroupList?.length || 0}}</p>
            <p class="action-buttons" style="width: 20%;padding-left: 25px;">
              <i class="bi bi-eye-fill" data-toggle="modal" data-target="#exampleModalView" (click)="viewRole(role)"></i>
              <i class="bi bi-check-circle-fill text-success mx-2" *ngIf="role.isSubmitted" title="Submitted"></i>
              <i class="bi bi-x-circle-fill text-danger mx-2" *ngIf="role.isError" title="Error"></i>
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModalView" tabindex="-1"  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Role
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div *ngFor="let role of singleRole; let i = index">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Role Name</label>
                <input value="{{role.roleName}}" type="text" class="form-control" readonly>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Level</label>
                <input value="{{role.level}}" type="text" class="form-control" readonly>
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <h5 class="sub-menu-heading">Screen Groups ( {{role.screenGroupList?.length || 0}} )</h5>
              
              <div *ngFor="let screenGroupList of role.screenGroupList; let k = index">
                <h6 style="color: #357df0;">Group: {{screenGroupList.groupName}}</h6>
                <div *ngFor="let screenPrivilegeList of screenGroupList.screenPrivilegeList; let j = index">
                  <div class="screenList">
                    <div class="sub-menu-block">
                      <div>
                        <label for="">sub menu name :</label>
                        <p> {{screenPrivilegeList.description}}</p>
                      </div>
                      <div>
                        <label for="">router link :</label>
                        <p> {{screenPrivilegeList.name}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="updateButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
